<template>
<div>
  <v-card v-if="editedItem" height="400px">
    <v-card-title>
      <span class="text-h5">{{ $t('admin.stories.editStory') }}</span>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="name"
              disabled
              :label="$t('story.title')"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-select
              v-model="status"
              :items="availableStatuses"
              item-text="id"
              item-value="id"
              attach
              :label="$t('story.status')"
            >
            </v-select>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="reset"> {{$t('forms.cancel')}} </v-btn>
      <ApolloMutation
        :mutation="(gql) => updateStoryQuery"
        :variables="{
          id: editedItem.id,
          status: status,
        }"
        @done="reset"
      >
        <template v-slot="{ mutate, loading, error }">
          {{ error ? error : '' }}
          <v-btn :loading="loading" color="blue darken-1" @click="mutate">
            {{ $t('forms.save')}}
          </v-btn>
        </template>
      </ApolloMutation>
    </v-card-actions>
  </v-card>
  </div>
</template>
<script>
import storyMutations from "@/graphql/StoryMutations";
export default {
  props: {
    availableStatuses: Array,
    editedItem: Object,
  },
  data() { 
    return {
      status: this.editedItem.status.id,
      name: this.editedItem.name,
    }
  },
  computed: {
    updateStoryQuery() {
      return storyMutations.updateStoryStatus;
    }
  },
  methods: {
    reset() {
      this.$emit("reset");
    },
  }
}
</script>
